import React from 'react';
import '../styles/Home.css';
import Header from '../components/Header.js'
import Projects from '../pages/Projects.js'
import Button from '../components/Button.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import {faLinkedin, faSquareGithub} from '@fortawesome/free-brands-svg-icons'
import Experience from './Experience.js';


const Home = () => {
  const handleButtonClick = () => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = 'files/resume.pdf';
    link.download = 'Chin_Yee_Lai_resume.pdf';
    link.click();
  };
  

  return (
    <div id="home" className="home w-screen ">
      <Header/>

      <section className="hero h-screen px-10 py-20">
        <div className="bg-blur text-left md:mt-28">
          <h1 className='md:text-5xl min-[320px]:text-3xl font-bold'>Chin Yee (Esther) Lai</h1>
          <h3 className='md:text-2xl min-[320px]:text-xl text-gray-700'>Fullstack Developer & Interaction Designer</h3>
          <br/>
          <p className=' md:text-xl min-[320px]:text-md'>
              Hi, I’m Esther, a Fullstack Developer and Interaction Designer currently working as a VB .NET Developer, modernizing legacy systems and building features to streamline business and legal processes. 
              I also create intuitive web applications, design seamless user experiences, and mentor students and peers to grow their technical skills.          </p>
          <br/>
          <Button className="button-primary" onClick={()=>document.getElementById("projects").scrollIntoView({behavior:'smooth'})}>View Projects</Button>
          
          <Button className='button-secondary' onClick={handleButtonClick}><FontAwesomeIcon className="mx-2" icon={faDownload}/>Resume</Button>

          <div className='mt-2'>
              <a class="text-4xl mx-2 " href="https://www.linkedin.com/in/chinyeelai"><FontAwesomeIcon icon={faLinkedin}/></a>
                  
              <a class="text-4xl " href="https://github.com/chinyee8"><FontAwesomeIcon icon={faSquareGithub} /></a>
          </div>
       </div>
      </section>

      <section id="experiences" className="experiences lg:min-h-screen px-10 py-20">
        <div className="bg-blur mt-16">
          <Experience />
        </div>
      </section>

      <section id="projects"className="projects lg:min-h-screen px-10 py-20">
          <div className="bg-project mt-16">
            <Projects />
          </div>
        </section>

      

    </div>
  );
};

export default Home;
